/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  index.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:31
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import ConfirmDialog from "./index.vue";
import Vue, {VueConstructor} from "vue";
import {mergeOptions} from "@/core/plugin_helper";

let $vm: any

interface ConfirmOptions {
    okText?: string;
    cancelText?: string;
    tips?: string;
    onOk?: () => unknown;
    onCancel?: () => void;
}

const install = (vue: VueConstructor, options = {}) => {
    let ConfirmDialogConstructor = vue.extend(ConfirmDialog)

    if (!$vm) {
        $vm = new ConfirmDialogConstructor({
            el: document.createElement('div'),
            propsData: {
                title: ''
            }
        })
        document.body.appendChild($vm.$el)
    }
    const confirm = {
        show (options: ConfirmOptions) {
            if (typeof options === 'object') {
                mergeOptions($vm, options)
            }
            $vm.$off('on-cancel')
            $vm.$off('on-ok')
            $vm.$on('on-cancel', () => {
                options && options.onCancel && options.onCancel()
                $vm.showConfirm = false
            })
            $vm.$on('on-ok', () => {
                if (options && options.onOk) {
                    const res = options.onOk()
                    if (res instanceof Promise) {
                        res.then(() => {
                            $vm.showConfirm = false
                        })
                    } else {
                        $vm.showConfirm = false
                    }
                }
            })

            $vm.showConfirm = true
        },
    }
    Object.defineProperty(vue.prototype, '$confirmDialog', {
        value: confirm
    })
}

Vue.use(install)

export default install
